import React, { ReactElement } from 'react';
import { Box, Button, makeStyles, Typography } from '@material-ui/core';
import { LocationDescriptor } from 'history';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import CircledBackArrow from 'components/Icons/CircledBackArrow';

const useStyles = makeStyles({
  headerTitle: {
    marginBottom: '2rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',

    '& .MuiButton-root:not(:last-child)': {
      marginRight: '4px',
    },
  },
  title: {
    margin: '0',
    flexGrow: 1,
  },
  backgroundImage: {
    position: 'fixed',
    bottom: 0,
    right: 0,
    height: '50vh',
    zIndex: 0,
  },
});

interface NoPaperPageContentProps {
  title: string | ReactElement;
  backRoute?: string;
  backAction?: () => void;
  createButtonLink?: LocationDescriptor<any>;
  updateButtonLink?: LocationDescriptor<any>;
  deleteButtonAction?: () => void;
  customButtons?: NoPaperPageButton[];
  noBackground?: boolean;
}

export interface NoPaperPageButton {
  text: string;
  action: () => void;
}

const NoPaperPageContent: React.FC<NoPaperPageContentProps> = ({
  title,
  backRoute,
  backAction,
  createButtonLink,
  updateButtonLink,
  deleteButtonAction,
  customButtons,
  children,
  noBackground,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      {backRoute && (
        <Box paddingBottom="2em">
          <Button component={Link} to={backRoute} startIcon={<CircledBackArrow />}>
            {t('back')}
          </Button>
        </Box>
      )}
      {backAction && (
        <Box paddingBottom="2em">
          <Button onClick={backAction} startIcon={<CircledBackArrow />}>
            {t('back')}
          </Button>
        </Box>
      )}
      <Box position="relative" zIndex={1}>
        <div className={classes.headerTitle}>
          <Typography variant="h1" className={classes.title}>
            {title}
          </Typography>
          {customButtons?.map(button => (
            <Button variant="outlined" onClick={button.action}>
              {button.text}
            </Button>
          ))}
          {createButtonLink && (
            <Button variant="outlined" component={Link} to={createButtonLink}>
              {t('create')}
            </Button>
          )}
          {updateButtonLink && (
            <Button variant="outlined" component={Link} to={updateButtonLink}>
              {t('update')}
            </Button>
          )}
          {deleteButtonAction && (
            <Button variant="outlined" onClick={deleteButtonAction}>
              {t('delete')}
            </Button>
          )}
        </div>
        {children}
      </Box>
      {!noBackground && <img className={classes.backgroundImage} alt="" src="/bg-pattern.png" />}
    </>
  );
};

export default NoPaperPageContent;
